import md5 from 'md5';
import localforage from 'localforage';
import utils from '@/common/libs/utils.js';
import CityCodeData from '@/common/libs/CityCodeData';

export const sk = process.env.NODE_ENV=='production'?'2myQerlMsFzoUYw5Z0nJoBKFDkgqCu3Y':'fbMsuvtfXa0QjKeFa39DgKD331JkMFNF';

export const downloadUrl = 'http://sj.qq.com/myapp/detail.htm?apkName=com.izhikang.student';

export const phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;

//export const passwordReg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!#$@_])[\da-zA-Z~!@#$%^&*]{6,18}$/;
//export const passwordReg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$@_()_+`\-={}:";'<>?,.\/]).{6,18}$/;
// export const passwordReg = /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}/;
export const passwordReg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;

export const localforageConfig = {
	name: 'izk-m-app',
	size: 4980736,
	version: 1.0,
	description: '学而思爱智康移动官网'
};

function getSign(obj){
  let arr = [];

  for(let key in obj){

    arr.push('' + key + obj[key]);
  }

  arr = arr.sort().join('') + sk;

  return md5(arr);
}

export {getSign};

//防抖函数
function throttle(func, wait){
	let timeout;

	return function(){
		let context = this;
		let args = arguments;

		clearTimeout(timeout);
		timeout = null;
		timeout  = setTimeout(function(){
			func.apply(context, args);
		}, wait);
	}
}

export {throttle};

//组合url和参数
function compareData(obj, url){
	url += '?';
	for(let key in obj){
		url += key + '=' + obj[key] + '&';
	}

	return url;
}

export {compareData};

//从缓存中获取存储的store
function getStore(){
	return new Promise(function(resoLVe, reject){
		localforage.getItem('izk-web-app').then(function(sotre){
			resoLVe(sotre);
		})
	})
}

export {getStore};

const upper = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
					'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

export {upper}

//深拷贝
let deepCopy = function(obj) {
    if (typeof obj !== 'object') {
		return;
    }
    var newObj = obj instanceof Array ? [] : {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key];
        }
    }
    return newObj;
}

export {deepCopy};

function isWeChat(navigat){
	let ua = navigat.userAgent.toLowerCase();

	if(ua.match(/MicroMessenger/i) == "micromessenger"){
		return true;
	}else{
		return false;
	}
}

export {isWeChat}

const subjects = [
	{
		id: 0,
		name: '数学',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '运算能力'
			},
			{
				key: 'LV2：60-75%',
				name: '抽象概括能力'
			},
			{
				key: 'LV3：75-85%',
				name: '推理能力'
			},
			{
				key: 'LV4：85-95%',
				name: '应用意识能力'
			},
			{
				key: 'LV5：95-100%',
				name: '解决问题能力'
			}
		]
	},
	{
		id: 1,
		name: '英语',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '基础感知能力'
			},
			{
				key: 'LV2：60-70%',
				name: '知识扩展输出能力'
			},
			{
				key: 'LV3：70-90%',
				name: '攻坚应用能力'
			},
			{
				key: 'LV4：90-100%',
				name: '探究能力'
			}
		]
	},
	{
		id: 2,
		name: '语文',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '识记能力'
			},
			{
				key: 'LV2：60-70%',
				name: '理解能力'
			},
			{
				key: 'LV3：70-80%',
				name: '分析综合能力'
			},
			{
				key: 'LV4：80-90%',
				name: '鉴赏评价能力'
			},
			{
				key: 'LV4：90-95%',
				name: '表达应用能力'
			},
			{
				key: 'LV4：95-100%',
				name: '探究能力'
			}
		]
	},
	{
		id: 3,
		name: '物理',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '基础能力'
			},
			{
				key: 'LV2：60-70%',
				name: '观察能力'
			},
			{
				key: 'LV3：70-80%',
				name: '分析概括能力'
			},
			{
				key: 'LV4：80-90%',
				name: '应用能力'
			},
			{
				key: 'LV590-100%',
				name: '探究能力'
			}
		]
	},
	{
		id: 4,
		name: '化学',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '基础能力'
			},
			{
				key: 'LV2：60-75%',
				name: '信息加工能力'
			},
			{
				key: 'LV3：75-90%',
				name: '分析能力'
			},
			{
				key: 'LV4：90-100%',
				name: '科学探究能力'
			}
		]
	},
	{
		id: 5,
		name: '生物',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '基础能力'
			},
			{
				key: 'LV2：60-75%',
				name: '理解能力'
			},
			{
				key: 'LV3：75-90%',
				name: '实验与探究能力'
			},
			{
				key: 'LV4：90-100%',
				name: '问题解决能力'
			}
		]
	},
	{
		id: 6,
		name: '政治',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '基础能力'
			},
			{
				key: 'LV2：60-75%',
				name: '观点理解能力'
			},
			{
				key: 'LV3：75-90%',
				name: '分析应用能力'
			},
			{
				key: 'LV4：90-100%',
				name: '实践参与能力'
			}
		]
	},
	{
		id: 7,
		name: '地理',
		subjects: [
			{
				key: 'LV1：0-60%',
				name: '基础能力'
			},
			{
				key: 'LV2：60-70%',
				name: '识别与描述能力'
			},
			{
				key: 'LV3：75-90%',
				name: '说明与归纳能力'
			},
			{
				key: 'LV4：90-100%',
				name: '分析与运用能力'
			}
		]
	},
	{
		id: 8,
		name: '历史',
		subjects: [
			{
				key: 'LV1：0-65%',
				name: '基础能力'
			},
			{
				key: 'LV2：65-80%',
				name: '进阶理解能力'
			},
			{
				key: 'LV3：80-90%',
				name: '分析与运用能力'
			},
			{
				key: 'LV4：95-100%',
				name: '实践参与能力'
			}
		]
	}
];

export {subjects};

/**
 * 请求结果返回后校验
 * @description 请求成功 401.需要登录 601.需要开卡/完善信息 其它各接口自行定义
 * @param {Object} data  请求返回的结果
 * @param {String} toRouterQuery  跳转到对应的页面，操作后跳转的页面
 */
function responseResultValidate (responseData,toRouterQuery,routerObj){
	if (process.browser){ //浏览器环境
		let city= CityCodeData.getCityByCode(utils.cookie.get('cityCode'));
		if (toRouterQuery && Object.keys(toRouterQuery).length != 0) {
			if(toRouterQuery.params && Object.keys(toRouterQuery.params).length != 0){
				toRouterQuery.params = utils.jsonToSerializer(toRouterQuery.params);
			}
			if(toRouterQuery.query && Object.keys(toRouterQuery.query).length != 0){
				toRouterQuery.query = utils.jsonToSerializer(toRouterQuery.query);
			}
		}
		if(responseData.errcode == 401) {
			if (toRouterQuery && Object.keys(toRouterQuery).length != 0) {
				if (routerObj) {
					routerObj.replace({
						name: 'login',
						query: toRouterQuery
					});
				} else {
					location.replace(`/${city.first_word}/login?${utils.jsonToSerializer(toRouterQuery)}`) ;
				}
			} else{
				if (routerObj) {
					routerObj.push({
						name: 'login'
					});
				} else {
					location.href = `/${city.first_word}/login`;
				}
			}
			return false;
		}else if(responseData.errcode == 601) {
			if (toRouterQuery && Object.keys(toRouterQuery).length != 0) {
				if (routerObj) {
					routerObj.push({
						name: 'supplementaryCardInfo',
						query: toRouterQuery
					});
				} else {
					location.href = `/${city.first_word}/supplementaryCardInfo?${utils.jsonToSerializer(toRouterQuery)}`;
				}
			} else {
				if(routerObj) {
					routerObj.push({
						name: 'supplementaryCardInfo'
					});
				} else {
					location.href = `/${city.first_word}/supplementaryCardInfo`;
				}
			}
			return false;
		}
		return true
	}
	return true
}
export {responseResultValidate}













// WEBPACK FOOTER //
// ./src/common/libs/common.js